import { useEffect } from 'react';

// Scroll-reveal choreography for anything carrying the .reveal class.
// A MutationObserver picks up nodes rendered later (async sections,
// lens swaps). The .reveals-active gate keeps content visible if JS fails.
// Revealed state is stored in a data attribute (React re-renders rewrite
// the class attribute and would wipe a class the observer added), and
// seen-tracking lives in a per-effect WeakSet so a StrictMode
// double-mount re-observes everything with the live observer.
export default function useReveal() {
    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

        document.documentElement.classList.add('reveals-active');

        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.setAttribute('data-revealed', '');
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }
        );

        const seen = new WeakSet();
        const observeAll = () => {
            document.querySelectorAll('.reveal:not([data-revealed])').forEach((el) => {
                if (seen.has(el)) return;
                seen.add(el);
                io.observe(el);
            });
        };

        observeAll();
        const mo = new MutationObserver(observeAll);
        mo.observe(document.body, { childList: true, subtree: true });

        return () => {
            io.disconnect();
            mo.disconnect();
            document.documentElement.classList.remove('reveals-active');
        };
    }, []);
}
